import { computedFrom } from 'aurelia-framework';
import { SortInstruction } from 'framework/aurelia_tools/sort-controller';

export class QueryMemory<TFilter> {
  filter: TFilter = null;
  sortInstruction: SortInstruction = null;

  initialize(type: (new () => TFilter)): this {
    if (this.filter == null)
      this.filter = new type();
    return this;
  }

  @computedFrom('sortInstruction.expression')
  get sortExpression(): string {
    return this.sortInstruction?.expression ?? null;
  }
}
